import React, { useState } from 'react';
import './Audit.css';
import { getCampaigns }  from '../services/campaigns';
import { getPDFAudit } from '../services/audit';
import { Oval } from 'react-loading-icons'
import { usePromiseTracker } from "react-promise-tracker";
import {useAuth } from '../AuthContext/AuthContext'
export default function Audit() {
    const { dispatch } = useAuth();
    const { promiseInProgress } = usePromiseTracker(); 
    const [selectedOption, setSelectedOption] = useState(0);
    const [campaigns, setCampaigns] = useState([]);
    const [idcampana, setIDCampana] = useState(0);

    function downloadPDF(pdf, filename) {
        const linkSource = `data:application/pdf;base64,${pdf}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = filename;
        downloadLink.click();
    }

    function getCamp(){
        getCampaigns(-2, dispatch.token).then(response => {
                setCampaigns(response.body);
        });
    }
    
    function handleChange(e) {
        if( !e ) e = window.event; 
        if(parseInt(e.target.value)===2 || parseInt(e.target.value)===7){
            getCamp();
        }
        setSelectedOption(parseInt(e.target.value)); 
     }

     function handleChange2(e) {
        if( !e ) e = window.event; 
        setIDCampana(parseInt(e.target.value)); 
     }
 
    function getPDF(tipo){
        getPDFAudit(tipo, idcampana, dispatch.token).then(response => {
            if(tipo===1)
                downloadPDF(response.body, "REPORTE_ASOCIADOS_REGISTRADOS.pdf");
            if(tipo===2)
                downloadPDF(response.body, "REPORTE_RESUMEN_VOTOS.pdf");
            if(tipo===3)
                downloadPDF(response.body, "REPORTE_VALIDACION_QUORUM.pdf");  
            if(tipo===4)
                downloadPDF(response.body, "REPORTE_RESUMEN_VOTOS.pdf");  
            if(tipo===5)
                downloadPDF(response.body, "REPORTE_ASOCIADOS_HABILITADOS.pdf");
            if(tipo===6)
                downloadPDF(response.body, "REPORTE_PARTICIPACIÓN_ORDINARIA.pdf");
            if(tipo===7)
                downloadPDF(response.body, "REPORTE_PARTICIPACIÓN_ASOCIADOS.pdf");   
            if(tipo===8)
                downloadPDF(response.body, "REPORTE_ASOCIADOS_REGISTRADOS_EXTRAORDINARIO.pdf");  
            if(tipo===9)
                downloadPDF(response.body, "REPORTE_PARTICIPACIÓN_EXTRAORDINARIA.pdf");                              
        });       
    }

    return(<div className="login-wrapper">
            <center>
                 <select style={{"marginTop": "15px"}} className="Dropdown-control" onChange={(e) => handleChange(e) } defaultValue="0" disabled={ promiseInProgress ? "disabled" : "" }>
                        <option key={1} value={1}>
                          Reporte de Solicitudes de Registro
                        </option>
                        <option key={2} value={2}>
                          Reporte de Votos General
                        </option>
                        <option key={6} value={6}>
                          Reporte de Participación Ordinaria
                        </option>
                        {<option key={7} value={7}>
                          Reporte de Quorum
                         </option>}
                        <option key={5} value={5}>
                           Reporte de Asociados Habilitados Para Votación
                        </option>   
                        <option defaultValue value="0" disabled="disabled">
                            { promiseInProgress ? "Cargando opciones..." : "Seleccione una opción"} 
                        </option>
                    </select>
                    <br/>
                    {selectedOption===2||selectedOption===7?(
                      <select className="Dropdown-control" onChange={(e) => handleChange2(e) } defaultValue="0" disabled={ promiseInProgress ? "disabled" : "" }>
                        {campaigns.map((obj) => (
                            <option key={obj.Nombre} value={obj.IDCampana}>
                                {obj.Nombre}
                            </option>
                            ))}
                            <option defaultValue value="0">
                            { promiseInProgress ? "Cargando opciones..." : "Reporte General"} 
                            </option>
                            
                    </select>      
                    ):(
                        <div></div>
                    )}
                    <br/>    

                    <button  className="button"  style={{"marginTop": "15px"}} onClick={ () => getPDF(selectedOption) } disabled={ promiseInProgress||selectedOption===0 ? "disabled" : "" } > 
                        { promiseInProgress ? "Obteniendo reporte..." : "Generar Reporte"} 
                        { promiseInProgress && <Oval className="loading-icon" /> }
                    </button>                  
        </center> 
        </div>
    )
}